import { Button, Pill, Typography } from "@fullscript/aviary-web";
import { faCircle } from "@fullscript/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";

import { SvgFullscriptLogoDarkTextGreenLeaf } from "@shared/assets/logo";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./ConnectHeader.styles";

interface Props {
  signInHref: string;
}

const ConnectHeader = ({ signInHref }: Props) => {
  const { t } = useTranslation();
  const { phoneLarge } = useBreakpoints();

  return (
    <header css={styles.header}>
      <div css={styles.brand}>
        <SvgFullscriptLogoDarkTextGreenLeaf css={styles.logo} />
        <Typography
          variant="footnote"
          colorIntensity="subtle"
          isMarginless
          customCss={styles.productName}
        >
          {t(l.connect.header.productName)}
        </Typography>
        <Pill size="xsmall" intention="success" icon={faCircle} customCss={styles.betaPill}>
          {t(l.connect.header.beta)}
        </Pill>
      </div>
      {!!phoneLarge.greaterThan && (
        <Button variant="secondary" size="small" href={signInHref}>
          {t(l.common.SignIn)}
        </Button>
      )}
    </header>
  );
};

export { ConnectHeader };
export type { Props as ConnectHeaderProps };
